module.exports = __webpack_public_path__ + "static/media/Cooperationbg2@3x.5dc75cc6.png";